<template>
  <div>
    <el-container class="p-3">
      <div>
        <el-form inline>
          <el-form-item label="經銷商">
            <selectCompany :id.sync="form.company_id" @onSelect="onSelectCompany" />
          </el-form-item>
          <el-form-item>
            <el-button
              v-if="$route.meta.action.c"
              type="primary"
              @click="
                updateDialog = true;
                form.name = '';
                form.id = null;
                form.description = '';
                edit = false;
              "
            >
              新增
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-container>

    <el-container class="px-3">
      <div class="" />
    </el-container>

    <el-table v-if="clients" :data="clients" style="width: 100%" stripe>
      <!-- <el-table-column prop="company.name" label="經銷商"> </el-table-column> -->
      <el-table-column prop="name" label="客戶名稱" width="300" />
      <el-table-column prop="description" label="說明" />
      <el-table-column label="動作">
        <template v-if="$route.meta.action.u" slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="
              updateDialog = true;
              form.name = scope.row.name;
              form.id = scope.row.id;
              form.description = scope.row.description;
              edit = true;
            "
            >編輯</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="客戶" :visible.sync="updateDialog" @closed="collapse = 2">
      <el-form ref="form" :rules="rules" :model="form">
        <el-form-item label="客戶名稱" prop="name">
          <el-input v-model="form.name" autocomplete="off" />
        </el-form-item>
        <el-form-item label="客戶說明">
          <el-input v-model="form.description" type="textarea" autocomplete="off" />
        </el-form-item>
        <el-form-item label="經銷商">
          <selectCompany :id.sync="form.company_id" @onSelect="onSelectCompany" />
        </el-form-item>
      </el-form>
      <el-collapse v-if="edit" v-model="collapse">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="text-danger">危險動作 <i class="header-icon el-icon-warning" /></div>
          </template>
          <el-popconfirm v-if="$route.meta.action.d" title="確定刪除?" @confirm="deleteItem(form.id)">
            <el-button slot="reference" type="danger">刪除客戶</el-button>
          </el-popconfirm>
        </el-collapse-item>
      </el-collapse>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateDialog = false">取消</el-button>
        <el-button type="primary" @click="update">確定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCompanyClients, updateClient, deleteClient } from '@/api/clients';
import selectCompany from '@/components/select/companies';
import ExportExcel from '@/components/ExportExcel/index.vue';
const methods = {
  async onSelectCompany() {
    this.clients = await getCompanyClients(this.form.company_id);
  },
  async onSelectCompanyInForm(company_id) {
    this.form.company_id = company_id;
  },

  async update() {
    const valid = await this.$refs['form'].validate().catch((err) => {
      return err;
    });
    if (!valid) return;

    try {
      const data = await updateClient(this.form);
      this.$message({
        message: '成功',
        type: 'success',
      });
      this.updateDialog = false;
      this.$refs['form'].resetFields();
      this.clients = await getCompanyClients(this.company_id);
    } catch (error) {}
  },
  async deleteItem(id) {
    try {
      const data = await deleteClient({ id });
      this.$message({
        message: '成功',
        type: 'success',
      });
      this.updateDialog = false;
      this.clients = await getCompanyClients(this.company_id);
    } catch (error) {}
  },

  handleSelectionChange(rows) {
    this.selected = rows;
  },
};
export default {
  components: {
    ExportExcel,
    selectCompany,
  },
  data() {
    return {
      updateDialog: false,
      collapse: 1,
      edit: false,
      clients: null,
      companies: [],
      company: '',
      form: {
        id: null,
        name: '',
        description: '',
        company_id: null,
      },
      selected: [],
      columns: [
        { label: '名稱', field: 'name' },
        { label: '說明', field: 'description' },
        { label: '經銷商', field: 'company.name' },
      ],
      rules: {
        name: [{ required: true, message: '必填', trigger: 'blur' }],
      },
    };
  },
  methods,
};
</script>
